import React from 'react';
import { Marker } from '@react-google-maps/api';

const LocationMarker = ({ id, position, icon, visible, width = null, showInfo = true, clickable = true, centerIcon, onClick }) => {
    const markerProps = {
        position,
        visible,
        clickable,
    };
    
    if (icon) {
        const originalWidth = parseInt(icon.width, 10);
        const originalHeight = parseInt(icon.height, 10);

        const iconWidth = width || originalWidth;
        const iconHeight = width ? (iconWidth / originalWidth) * originalHeight : originalHeight;
        
        markerProps.icon = {
            url:        icon.url,
            size:       {
                width:  iconWidth,
                height: iconHeight
            },
            scaledSize: {
                width:  iconWidth,
                height: iconHeight
            }
        };
        
        if (centerIcon) {
            markerProps.icon.anchor = {
                x: iconWidth / 2,
                y: iconHeight / 2
            };
        }
    }
    
    if (showInfo) markerProps.onClick = () => onClick(id);
    
    
    return (
        <Marker {...markerProps}/>
    );
};

export default LocationMarker;
